import React from 'react';
import * as moment from "jalali-moment";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {useLocation} from "react-router-dom";
import styled from "@emotion/styled";
import {Switch} from "@mui/material";
import {setValidations} from "../../redux/public/actions";
import {useDispatch, useSelector} from "react-redux";


export const convertPrice = (price) => {
  if (price && price != 'undefined') {
    const str = price?.toString()?.split(".");
    if (str[0]?.length >= 4) {
      str[0] = str[0]?.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    if (str[1] && str[1]?.length >= 5) {
      str[1] = str[1]?.replace(/(\d{3})/g, "$1 ");
    }
    return str.join(".");
  }
}

export const convertDate = (date) => {
  return moment(date, 'YYYY/MM/DD').locale('fa').format('LL')
}

export const convertTime = (time) => {
  return moment(time, 'HH:MM:SS').locale('fa')
}

export const addCommas = e => e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
export const removeNonNumeric = e => e.toString().replace(/[^0-9]/g, "");
export const removeNumeric = e => {
  var re = new RegExp(/[^\u0660-\u0669A-Za-z]/g);
  if (re.test(e.toString())) {
    return e.toString().replace(re, "")
  } else {
    return e.toString()
  }
};
export const removeCommas = e => e.split(',').join('');
export const convertI98ToZero = (e) => e.replace(/^\"98"/, "0");
export const checkNonZeroPrefix = (e) => {
  const regex = /^[1-9]{6}/; // عبارت منظم برای تطابق با 6 کاراکتر ابتدایی غیر از صفر
  return regex.test(e);
};
export const checkEmail = (e) => {
  let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
  // console.log('regex', regex.test(e) , e)
  return regex.test(e);
};


var transformNumbers = (function () {
  var numerals = {
    persian: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    arabic: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"]
  };

  function fromEnglish(str, lang) {
    var i, len = str.length, result = "";

    for (i = 0; i < len; i++)
      result += numerals[lang][str[i]];
    return result;
  }

  return {
    toNormal: function (str) {
      var num, i, len = str.length, result = "";

      for (i = 0; i < len; i++) {
        num = numerals["persian"].indexOf(str[i]);
        num = num != -1 ? num : numerals["arabic"].indexOf(str[i]);
        if (num == -1) num = str[i];
        result += num;
      }
      return result;
    },
    toPersian: function (str, lang) {
      return fromEnglish(str, "persian");
    },
    toArabic: function (str) {
      return fromEnglish(str, "arabic");
    }
  }
})();

function ToJsutNumber(value) {

  var hasZero = false;
  var zeroCount = 0;
  if (value.startsWith("0") && value.length > 1) {
    hasZero = true;
    for (var i = 0; i < value.length; i++) {
      if (value[i] == '0')
        zeroCount++;
      else
        break;
    }
    if (zeroCount && zeroCount > 0)
      value = value.slice(zeroCount, value.length);
  }
  var value = transformNumbers.toNormal(value);
  var result = (value.replace(/[^\d]+/gi, ''));
  if (hasZero) {
    var p = '0';
    result = p.repeat(zeroCount) + (result.toString());
  }
  return result;
}

function ToLocalInt(value) {

  var hasZero = false;

  var value = transformNumbers.toNormal(value);
  var result = (parseInt(value.replace(/[^\d]+/gi, '')) || 0);
  if (hasZero) {
    result = '0' + (result.toString());
  }
  return result.toLocaleString('en-US');
}


export const handleSetQuery = () => {
  // const location = useLocation();
  // console.log('location', location)
  // // return searchParams.get('state') && searchParams.get('state') !== "null" &&  ({
  // //   state: searchParams.get('state') || ""
  // // }).toString()
  // const setQuery = () => {
  //   return location?.search
  // }
  //
  // return {setQuery}
}


export const handleScrollIntoView = (e) => {
  e.current?.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
};


export const HandlerShowMessage = () => {
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar()

  const showMessage = (e) => {
    switch (e) {
      case 200:
        return enqueueSnackbar(t("msg.t7"), {
          variant: 'success',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      case 400:
        return enqueueSnackbar(t("msg.t9") + ' - ' + "400", {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      case 404:
        return enqueueSnackbar(t("msg.t8") + ' - ' + "404", {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      case 502:
        return enqueueSnackbar(t("msg.t9") + ' - ' + "502", {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      case 600:
        return enqueueSnackbar(t("msg.t10"), {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      case "ERR_NETWORK":
        return enqueueSnackbar(t("msg.t12"), {
          variant: 'error',
          TransitionProps: {
            direction: 'down',
          },
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top'
          }
        })
      default:
        return null
    }
  }

  return {showMessage}
}

export const useShowMessageComponent =  () => {
  const {enqueueSnackbar} = useSnackbar()

  let limit = 0

  const showMessageComponent = async (e, variant) => {
    if(limit < 1){
      await enqueueSnackbar(e || 'مشکلی رخ داده است', {
        variant: variant || 'success',
        TransitionProps: {
          direction: 'right',
        },
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        autoHideDuration: 3000
      })
      limit++
    }
  }

  return {showMessageComponent}
}

export const handleCheckNationalCode = (e) => {
  return String(e)
     .toLowerCase()
     .match(/^[0-9]{10}$/);
};

export const handleSetServicesLogo = (e) => {
  switch (e) {
    case "Mail Express":
      return require('../img/services/4.png')
    case "بسته پس کرایه ماهکس":
      return require('../img/services/11.png')
    case "پس کرایه پستبار اکسپرس":
      return require('../img/services/14.png')
    case "پس کرایه پیشتاز":
      return require('../img/services/12.png')
    case "پست پیشتاز":
      return require('../img/services/12.png')
    case "پستبار اکسپرس":
      return require('../img/services/14.png')
    case "پیک هاب - توزیع":
      return require('../img/services/15.png')
    case "پیک هاب-تعارف":
      return require('../img/services/15.png')
    case "پیک هاب-لینک اکسپرس":
      return require('../img/services/15.png')
    case "راه آسمان آبی":
      return require('../img/services/6.png')
    case "سرویس اسکای پست":
      return require('../img/services/18.png')
    case "سرویس اکسپرس-پرداخت توسط گیرنده-چاپار":
      return require('../img/services/9.png')
    case "سرویس اکسپرس-چاپار":
      return require('../img/services/9.png')
    case "سرویس پرداخت توسط گیرنده-چاپار":
      return require('../img/services/9.png')
    case "سرویس پودو":
      return require('../img/services/16.png')
    case "سرویس چاپار":
      return require('../img/services/9.png')
    case "سرویس حمل بار اوبار":
      return require('../img/services/12.png')
    case "ماهکس":
      return require('../img/services/11.png')
    case "کالارسان - پست اتوبوسی":
      return require('../img/services/7.png')
    case "اسنپ":
      return require('../img/services/1.png')
    case "اسپید":
      return require('../img/services/2.png')
    case "ارامکس":
      return require('../img/services/8.png')
    case "ppt":
      return require('../img/services/10.png')
    case "ندکس":
      return require('../img/services/13.png')
    case "گنجه":
      return require('../img/services/3.png')
    case "یارباکس":
      return require('../img/services/17.png')
    case "بیوپست":
      return require('../img/services/19.png')
    case "اسکای":
      return require('../img/services/18.png')
    case "pme":
      return require('../img/services/20.png')
    default:
      return require('../img/services/14.png')
  }
}

export const handleReverseUnderline = (e) => {
  const item = e?.split('_')
  const final = item.reverse().join('_')
}

export const handleCheckAddressWithState = (a, c, s) => !a.split('،')[0].includes(c)

export const handleBorderColor = (e) => e && {border: '1px solid #FF3636'}

export const HandleValidationMethod = () => {
  const dispatch = useDispatch();
  const {showMessageComponent} = useShowMessageComponent()

  const validationMethod = (ref, key, message) => {
    dispatch(setValidations({[key]: message}))
    handleScrollIntoView(ref)
    showMessageComponent(message, 'error')
  }

  return{validationMethod}
}
